import React from 'react'
import ActiveItemMakeOfferButton from './ActiveItemMakeOfferButton'
import ActiveItemMarketplaceBuy from './ActiveItemMarketplaceBuy'
import ActiveItemCancelListing from './ActiveItemCancelListing'
import ActiveItemDivider from './ActiveItemDivider'
import ActiveItemSellButton from './ActiveItemSellButton'

const ActiveItemMarketplaceButton = ({ tag, isListed, isMine }) => {

  if (isMine === false) {
    return (
      <>
        {
          tag === 'Not Listed' && <ActiveItemMakeOfferButton />
        }
        {
          isListed && <ActiveItemMarketplaceBuy />
        }
      </>
    )
  } else if (isMine && isListed) {
    return <>
      <ActiveItemCancelListing />
      <ActiveItemDivider />
    </>
  } else if (isMine && !isListed) {
    return (
      <>
        <ActiveItemSellButton />
        <ActiveItemDivider />
      </>
    )
  }
}

export default ActiveItemMarketplaceButton
